import { DUE_DATE } from 'customer-data-objects/task/TaskPropertyNames';
import { getDueDatePresets, getUISelectFormattedOptions } from 'task-forms-lib/utils/RelativeDatePresets';
import { getCrmSettingsTasksRemindersLink } from 'task-forms-lib/utils/links';
// @ts-expect-error untyped
import TaskDueDateInput from 'task-forms-lib/input/TaskDueDateInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useEffect, useState } from 'react';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIButton from 'UIComponents/button/UIButton';
import H5 from 'UIComponents/elements/headings/H5';
import Small from 'UIComponents/elements/Small';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UISection from 'UIComponents/section/UISection';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function FollowUpTasksPopoverBody(props) {
  // Save props that were passed when the popover was opened.
  // This avoids bugs (e.g. TASKS-1926) when the table is reloaded behind this
  // popover and the task details are swapped out for a new one.
  const [savedProps] = useState(props);
  const {
    onClose,
    taskDefaults,
    taskProperties,
    taskTitle,
    onSubmit
  } = savedProps;
  const [dueDateValue, setDueDateValue] = useState(taskDefaults[DUE_DATE]);
  const options = getUISelectFormattedOptions(getDueDatePresets());
  const defaultDueDate = taskDefaults[DUE_DATE];
  const popoverBodyMessage = taskTitle ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "taskFormsLib.followUp.taskTitleBodyMessage",
    options: {
      taskTitle
    }
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "taskFormsLib.followUp.emptyTaskTitleBodyMessage"
  });
  useEffect(() => {
    if (dueDateValue == null && defaultDueDate) {
      setDueDateValue(defaultDueDate);
    }
  }, [defaultDueDate, dueDateValue]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "taskFormsLib.followUp.header"
      })
    }), /*#__PURE__*/_jsxs(UISection, {
      children: [popoverBodyMessage, taskProperties[DUE_DATE] ? /*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(TaskDueDateInput, {
          "data-field": taskProperties[DUE_DATE].name,
          "data-selenium-test": `property-input-${taskProperties[DUE_DATE].name}`,
          "data-test-id": "due-date-property-input",
          objectType: 'TASK',
          onChange: evt => setDueDateValue(+evt.target.value),
          options: options,
          value: dueDateValue == null ? dueDateValue : `${dueDateValue}`
        })
      }) : /*#__PURE__*/_jsx(UILoadingSpinner, {
        grow: true
      })]
    }), /*#__PURE__*/_jsxs(UIFlex, {
      className: "m-bottom-4",
      direction: "column",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "m-bottom-2",
        children: [/*#__PURE__*/_jsx(UIButton, {
          "data-selenium-test": "task-create-followup-task",
          onClick: () => onSubmit(dueDateValue),
          size: "small",
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "taskFormsLib.followUp.addTask"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          "data-selenium-test": "close-followup-button",
          onClick: onClose,
          size: "small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "taskFormsLib.followUp.cancel"
          })
        })]
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "taskFormsLib.followUp.settingLinkMessage",
          options: {
            link: /*#__PURE__*/_jsx(UILink, {
              href: getCrmSettingsTasksRemindersLink(),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "taskFormsLib.followUp.taskSettings"
              })
            })
          }
        })
      })]
    })]
  });
}
const FollowUpTasksPopover = props => {
  return /*#__PURE__*/_jsx(UIPopover, {
    arrowSize: "none",
    open: props.isOpen,
    animateOnMount: true,
    style: {
      maxWidth: '500px'
    },
    placement: "top right",
    onOpenChange: () => props.setIsOpen(prev => !prev),
    onCloseComplete: props.onCloseComplete,
    content: {
      body: /*#__PURE__*/_jsx(FollowUpTasksPopoverBody, Object.assign({}, props))
    },
    children: props.children
  });
};
export default FollowUpTasksPopover;